import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { ToastService } from 'src/app/core/toast.service';
import { environment } from 'src/environments/environment';

import { getAllUserSubscrptions, getClient, practice, practiceDisplay, professional, professionalDeaData, professionalDisplay, supplier, supplierDisplay, updatePracticeDetails, updatePracticeImage, updateProfDetails, updateProfImage, updateSupplierDetails, updateSupplierImage } from '../queries/profile.query';
@Injectable()
export class ProfileService {

  constructor(private apollo: Apollo,private http: HttpClient,private toast: ToastService,) { }


  getUserProfileProfessional(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: professionalDeaData,
      variables: {id}
    }).pipe(pluck('data', 'dental_professionals_by_pk'));
  }

  getUserData(id){
    console.log(id)
    return this.apollo.subscribe({
      query: getClient,
      variables: {id}
    }).pipe(pluck('data', 'clients_by_pk'));
  }

  getUserProfileSuplier(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: supplier,
      variables: {id}
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

  getUserProfilePracice(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: practice,
      variables: {id}
    }).pipe(pluck('data', 'dental_practices_by_pk'));
  }


  getProfDisplay(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: professionalDisplay,
      variables: {id}
    }).pipe(pluck('data', 'dental_professionals_by_pk'));
  }

  getSupplierDisplay(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: supplierDisplay,
      variables: {id}
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

  getPracticeDisplay(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: practiceDisplay,
      variables: {id}
    }).pipe(pluck('data', 'dental_practices_by_pk'));
  }

  getuserSub(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getAllUserSubscrptions,
      variables: {id}
    }).pipe(pluck('data', 'user_subscriptions'));
  }



 async checkData(phoneObj){

    //const a = {object:phoneObj}

      try {
      const response = await this.http.post(`${environment.serverPath}/api/v1/auth/send-verify-otp`, phoneObj).toPromise();
      console.log('email test rk');
      return response;
    } catch (error) {
      console.log(error)
      throw error;
    }



  }


// async checkData(phoneObj){

//   //const a = {object:phoneObj}

//     try {
//     const response = await this.http.post(`${environment.serverPath}/api/v1/auth/send-verify-otp`, phoneObj).toPromise();
//     return response;
//   } catch (error) {
//     console.log(error)
//     throw error;
//   }



// }


​
async verifyOtp(otpData){

  console.log(otpData)

  try {
    const response = await this.http.post(`${environment.serverPath}/api/v1/auth/verify-otp`, otpData).toPromise();
    return response;
  } catch (error) {
    console.log(error)
    throw error;
  }


}
  

   // async register(user): Promise<any> {

  //   let headers = {"x-hasura-admin-secret":`${environment.x_hasura_admin_secret}`};
  //   //headers.append('Content-Type', 'application/json');
  //   //headers.append('x-hasura-admin-secret', `${environment.x_hasura_admin_secret}`);
  //   console.log(user)
  //   const a = {object:user}
  //   try {
  //     const response = await this.http.post(`${environment.serverBasePath}/api/rest/add-lead`, a, { headers : headers }).toPromise();
  //     return response;
  //   } catch (error) {
  //     console.log(error)
  //     throw error;
  //   }
  // }





  async updateProf(id,profObj):Promise<any>{
    console.log(profObj)
    console.log(id)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateProfDetails,
      variables: {id,profObj}
    }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }

  async updateSupplier(id, supplierObj):Promise<any>{
    console.log(id,supplierObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateSupplierDetails,
      variables: {id,supplierObj}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }


  async updatePractice(id,practiceObj):Promise<any>{
    console.log(practiceObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updatePracticeDetails,
      variables: {id,practiceObj}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }


  async updateUserImageProf(id,userImage):Promise<any>{
    console.log(userImage)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateProfImage,
      variables: {id,userImage}
    }).pipe(pluck('data', 'update_dental_professionals')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }

  async updateUserImageSupplier(id,userImage):Promise<any>{
    console.log(userImage)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updateSupplierImage,
      variables: {id,userImage}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }

  async updateUserImagePractice(id,userImage):Promise<any>{
    console.log(userImage)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: updatePracticeImage,
      variables: {id,userImage}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Updated SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }



  
}
